import { Box } from '@mantine/core';
import { Outlet, createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

const userDocumentsSearchSchema = z.object({
  userId: z.coerce.number().nullish(),
  disciplineId: z.coerce.number().nullish(),
  departmentId: z.coerce.number().nullish(),
  facultyId: z.coerce.number().nullish(),
});

export const Route = createFileRoute('/_auth/administration/_administration/user-documents/_user-documents')({
  component: RouteComponent,
  validateSearch: userDocumentsSearchSchema,
  staticData: {
    pageTitle: { id: 'sidebar.userDocuments' },
  },
});

function RouteComponent() {
  return (
    <Box p="md">
      <Outlet />
    </Box>
  );
}
